import m, {Vnode} from "mithril";
import {TInterviewThreadGoalsSidebarViewModel} from "../model/TInterviewThreadViewModel";

export type TGoalsSidebarAttrs = {
    model: TInterviewThreadGoalsSidebarViewModel,
    translate: (key: string) => string,
    onOpen: () => void,
    onClose: () => void,
};

export default class GoalsSidebarView {

    public view(vnode: Vnode<TGoalsSidebarAttrs>): Vnode|null {
        const {model, translate, onOpen, onClose} = vnode.attrs;
        if (!model.testMode) {
            return null;
        }

        if (!model.open) {
            return m("button.interview-thread-goals-trigger.btn.shadow.col-auto", {
                type: "button",
                onclick: onOpen,
                "aria-label": translate("interview_show_goals"),
            }, [
                m("span.interview-thread-goals-trigger-label", translate("interview_show_goals")),
            ]);
        }

        return m(".interview-thread-sidebar.border-start.d-flex.flex-column", [
            m(".interview-thread-sidebar-header.d-flex.align-items-center.justify-content-between.gap-3.p-3.border-bottom", [
                m("h4.mb-0", translate("your_goals")),
                m(".d-flex.align-items-center.gap-2", [
                    m(".interview-thread-timer.badge.d-inline-flex.align-items-center.gap-1", {
                        class: model.completed ? "text-bg-success" : "text-bg-light text-secondary",
                        title: translate("interview_test_duration"),
                        "aria-label": translate("interview_test_duration"),
                    }, [
                        m("i.bi.bi-clock"),
                        model.elapsedTime,
                    ]),
                    m("button.btn-close.flex-shrink-0", {
                        type: "button",
                        onclick: onClose,
                        "aria-label": translate("interview_close_goals"),
                    }),
                ]),
            ]),
            m(".interview-thread-sidebar-body.flex-grow-1.overflow-auto.p-3", [
                m(".d-flex.flex-column.gap-2", model.goals.map(goal => m(".interview-thread-goal.d-flex.flex-row.align-items-center", [
                    m(".interview-thread-goal-icon.badge.rounded-pill.text-bg-light.d-flex.align-items-center.justify-content-center.fs-5.me-2.p-1", [
                        goal.isCompleted
                            ? m("i.bi.bi-check-circle-fill.text-success", {title: translate("goal_completed")})
                            : m("i.bi.bi-circle.text-secondary", {title: translate("goal_pending")}),
                    ]),
                    m(".interview-thread-goal-description", goal.description),
                ]))),
            ]),
            model.backToEditUrl
                ? m(".interview-thread-sidebar-footer.flex-shrink-0.mt-auto.p-3.border-top.d-flex.justify-content-start", [
                    m("a.btn.btn-outline-dark", {href: model.backToEditUrl}, [
                        m("i.bi.bi-arrow-return-left.me-2"),
                        translate("interview_back_to_edit"),
                    ]),
                ])
                : null,
        ]);
    }

}
